import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import WrappedInfographicView from './InfographicView';

const StyledDiv = styled.div`
  .draggable-box {
    color: white;
    width: 200px;
    overflow: hidden;
  }

  .draggable-box > div {
    display: flex;
    letter-spacing: 1px;
  }

  .infographic-box {
    display: flex;
    flex-direction: row;
  }

  .infographic-box .left {
    float: left;
    width: 90%;
    background-color: green;
  }

  .infographic-box .left .left-inner {
    padding: 5px;
  }

  .infographic-box .right {
    float: right;
    width: 10%;
    background-color: #69cb45;
  }

  .infographic-box .bottom {
    display: flex;
    padding-left: 5px;
    padding-bottom: 2px;
    align-items: baseline;
    background-color: white;
    color: black;
  }

  .infographic-box .id {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 1.1rem;
  }

  .infographic-box .description {
    font-size: 1.3rem;
    white-space: nowrap;
    overflow: hidden;
    font-weight: 100;
    padding-right: 5px;
  }

  .infographic-box .bottom .value {
    font-size: 1.8rem;
    padding-right: 2px;
  }

  .infographic-box img {
    max-width: 100%;
    max-height: 100%;
  }
`;

class Container extends Component {
  static propTypes = {
    loader: PropTypes.func,
    pollInterval: PropTypes.number,
  };

  state = {
    values: {},
  };

  moveBox = (id, left, top) => {
    const position = {
      left: left / this.props.size.width,
      top: top / this.props.size.height,
    };
    this.props.updatePosition(id, position);
  };

  async componentDidMount() {
    await this.loadData();
    if (this.props.pollInterval) {
      this.interval = setInterval(this.loadData, this.props.pollInterval);
    }
  }

  loadData = async () => {
    const values = await this.props.loader();
    this.setState({
      values,
    });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      size: { width, height },
      boxes: rawBoxes,
      image,
      styledWrapper,
    } = this.props;
    const { values } = this.state;
    const boxes = rawBoxes.map(b => ({
      ...b,
      left: b.left * width,
      top: b.top * height,
      value: values[b.id],
    }));
    const OuterComponent = styledWrapper ? styledWrapper : StyledDiv;
    return (
      <OuterComponent>
        <WrappedInfographicView
          boxes={boxes}
          image={image}
          moveBox={this.moveBox}
        />
      </OuterComponent>
    );
  }
}

Container.defaultProps = {
  loader: () => {},
  pollInterval: null,
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/Infographic/index.js